<template>
  <b-row>
    <b-col
      cols="12"
      md="7"
    >
      <b-card>
        <b-row>
          <template v-if="!dataItem.id">
            <b-col
              cols="12"
              md="6"
            >
              <b-button
                block
                variant="gradient-success"
                size="lg"
                :disabled="selected === 'bank'"
                @click="setType('bank')"
              >
                <FeatherIcon
                  icon="ShieldIcon"
                  size="24"
                />
                Banka Havalesi
              </b-button>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-button
                variant="gradient-success"
                size="lg"
                block
                :disabled="selected === 'safe'"
                @click="setType('safe')"
              >
                <FeatherIcon
                  icon="InboxIcon"
                  size="24"
                />
                Elden Nakit
              </b-button>
            </b-col>
          </template>
          <template v-else>
            <b-col
              md="12"
            >
              <b-button
                variant="gradient-success"
                size="lg"
                block
                disabled
              >
                <FeatherIcon
                  :icon="selected === 'safe'? 'InboxIcon' : 'ShieldIcon'"
                  size="24"
                />
                {{ selected === 'safe' ? 'Elden Nakit' : 'Banka Hesabı' }}
              </b-button>
            </b-col>
          </template>
          <b-col
            cols="12"
          >
            <template v-if="selected === 'safe'">
              <hr>
              <donation-groups />
              <safe-accounts />
              <donate-date />
              <amount />
              <receipt />
              <receipt-no v-if="dataItem.is_receipt === '1'" />
              <notes-text />
              <update-notes v-if="dataItem.id" />
            </template>
            <template v-if="selected === 'bank'">
              <hr>
              <donation-groups />
              <bank-accounts />
              <donate-date />
              <amount />
              <notes-text />
              <update-notes v-if="dataItem.id" />
            </template>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col
      cols="12"
      md="5"
    >
      <preview-card />
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BButton, BRow, BCol,
} from 'bootstrap-vue'
import Amount from '@/views/Admin/Account_activities/Incomes/elements/Amount.vue'
import DonationGroups from '@/views/Admin/Account_activities/Incomes/elements/DonationGroups.vue'
import BankAccounts from '@/views/Admin/Account_activities/Incomes/elements/BankAccounts.vue'
import SafeAccounts from '@/views/Admin/Account_activities/Incomes/elements/SafeAccounts.vue'
import NotesText from '@/views/Admin/Account_activities/Incomes/elements/Notes.vue'
import UpdateNotes from '@/views/Admin/Account_activities/Incomes/elements/UpdateNotes.vue'
import Receipt from '@/views/Admin/Account_activities/Incomes/elements/Receipt.vue'
import ReceiptNo from '@/views/Admin/Account_activities/Incomes/elements/Receipt_no.vue'
import DonateDate from '@/views/Admin/Account_activities/Incomes/elements/DonateDate.vue'
import PreviewCard from '@/views/Admin/Account_activities/Incomes/PreviewCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    Amount,
    DonationGroups,
    BankAccounts,
    SafeAccounts,
    NotesText,
    UpdateNotes,
    Receipt,
    ReceiptNo,
    DonateDate,
    PreviewCard,
  },
  data() {
    return {
      selected: 'bank',
    }
  },
  computed: {
    dataItem() {
      const data = this.$store.getters['accountActivities/dataItem']
      if (data.id) {
        if (data.id_bank_accounts) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.selected = 'bank'
        }
        if (data.id_safes) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.selected = 'safe'
        }
      }
      return data
    },
  },
  methods: {
    setType(type) {
      if (!this.dataItem.id) {
        this.$store.commit('accountActivities/RESET_DATA_ITEM')
      }
      this.selected = type
      this.dataItem.is_receipt = '1'
    },
  },
}
</script>
